import { httpClient } from '@/services/http/httpClient'

type GetPortfolioProjectTagsParams = {
  portfolioId: string
}

type GetPortfolioProjectTagsResponse = {
  tags: {
    id: string
    name: string
    color: string
    textColor: string
  }[]
}

export async function getPortfolioTags({
  portfolioId,
}: GetPortfolioProjectTagsParams) {
  const { data } = await httpClient.get<GetPortfolioProjectTagsResponse>(
    `/projects/portfolio-tags/${portfolioId}`,
  )

  return data.tags
}
